import React, {useEffect} from 'react';
import {Select} from "antd";
import TableConfigDetailView from "./TableConfigDetailView";
import TableConfigCreateModal from "./TableConfigCreateModal";
import {useDispatch, useSelector} from "react-redux";
import {
    getAllTableLocations,
    getDynamicTableList,
    getInstallationDevices,
    getInstallationSelectData,
    getUniqDeviceParams,
    setInitState,
    setSelectedInstallation,
    setShowCreateModal
} from "../../redux-store/dynamicTable";
import {dynamicTableList, dynamicTableListLoading, installationSelectData} from "../../redux-store/selectors";
import Loader from "../ApplicationComponent/Loader";
import {SELECTED_INSTALLATION} from "../../constants/variables";

const {Option} = Select

function TableConfigListView() {

    const {loading, options, selected} = useSelector(installationSelectData)
    const tableList = useSelector(dynamicTableList)
    const tableListLoading = useSelector(dynamicTableListLoading)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getInstallationSelectData())
        dispatch(getUniqDeviceParams())
        return () => {
            dispatch(setInitState())
        }
    }, [])


    useEffect(() => {
        const selectItem = localStorage.getItem(SELECTED_INSTALLATION);
        if (selectItem !== null) {
            let obj = {
                value: JSON.parse(selectItem).value,
                label: JSON.parse(selectItem).label
            }
            dispatch(setSelectedInstallation(obj))

        } else {
            dispatch(setSelectedInstallation({
                label: options[0]?.name, value: options[0]?.id
            }))
        }
    }, [])

    useEffect(() => {
        if (selected?.value) {
            localStorage.setItem(SELECTED_INSTALLATION,JSON.stringify(selected));
            dispatch(getInstallationDevices(selected.value))
            dispatch(getDynamicTableList(selected.value))
            dispatch(getAllTableLocations(selected.value))
        }
    }, [selected])

    return (<>
            <div className={"container-fluid"}>
                <div className={"row pt-3 pb-3 bottom-line"}>
                    <div className={"col-12 col-md-6 col-lg-6 col-xl-6"}>
                        <div className="d-flex align-items-center installation-select">
                            <label className="home-page-label">Tabele</label>
                            <div className="col-7 col-md-7 col-lg-5 col-xl-4 ant-select-installations">
                                <Select labelInValue style={{width: "200px"}} loading={loading}
                                        onChange={(obj) => dispatch(setSelectedInstallation(obj))} value={selected}>
                                    {options.map((item) => {
                                        return (<Option key={item.id} value={item.id}>{item.name}</Option>)
                                    })}
                                </Select>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"row pt-3 d-flex justify-content-center"}>
                    <div className={"col-12 col-md-12 col-lg-10 col-xl-10"}>
                        <div className={"device-body-header"}>
                            <h5 className={"font-bold"}>{selected.label}</h5>
                            <button className={"btn btn-location"}
                                    onClick={() => dispatch(setShowCreateModal(true))}>Nova tabela
                            </button>
                        </div>
                        {tableListLoading ? <Loader/> : (<div className={"device-body-cards pt-3"}>
                            {tableList.map((table) => (<TableConfigDetailView key={table.id} id={table.id}/>))}
                        </div>)}
                    </div>
                </div>
            </div>
            <TableConfigCreateModal/>
        </>

    );
}

export default TableConfigListView;